import { render, staticRenderFns } from "./MMP_NewUserModal.vue?vue&type=template&id=24dc6648&"
import script from "./MMP_NewUserModal.vue?vue&type=script&lang=js&"
export * from "./MMP_NewUserModal.vue?vue&type=script&lang=js&"
import style0 from "./MMP_NewUserModal.vue?vue&type=style&index=0&id=24dc6648&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports